import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import { getScanTypeDetailsQueryKey } from './queries';
import { ScanTypeDetails } from './schemas';
import { PatchScanTypePayload, scanTypesService } from './service';

type MutationOptions = Omit<UseMutationOptions<ScanTypeDetails, Error, PatchScanTypePayload>, 'mutationFn'>;

export const useScanTypeMutation = (id: number, options?: MutationOptions) => {
    const queryClient = useQueryClient();

    return useMutation<ScanTypeDetails, Error, PatchScanTypePayload>({
        mutationFn: (data) => scanTypesService.patchScanType(id, data),
        ...options,
        onSuccess: (data, ...rest) => {
            // update the cache with the updated data, this will save us a network request
            queryClient.setQueryData(getScanTypeDetailsQueryKey(id), data);
            // call the original onSuccess if it exists
            options?.onSuccess?.(data, ...rest);
        }
    });
};
